import { marked } from "marked";

const FRONTMATTER_RE = /^---\r?\n([\s\S]*?)\r?\n---\r?\n([\s\S]*)$/;

export function parseFrontmatter(raw: string): { meta: Record<string, string>; body: string } {
  const match = raw.match(FRONTMATTER_RE);
  if (!match) return { meta: {}, body: raw };
  const [, block, body] = match;
  const meta: Record<string, string> = {};
  for (const line of block.split("\n")) {
    const idx = line.indexOf(":");
    if (idx === -1) continue;
    meta[line.slice(0, idx).trim()] = line.slice(idx + 1).trim();
  }
  return { meta, body };
}

export function renderMarkdown(body: string): string {
  return marked.parse(body, { async: false }) as string;
}

export function formatContentDate(iso: string): string {
  if (!iso) return "";
  return new Date(`${iso}T00:00:00Z`).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  });
}

// Shared by blog + news frontmatter: an Openverse (openverse.org) image is
// optional, free, keyless, and its `attribution` string carries the
// creator + license text their API terms require us to display verbatim.
export interface ContentImage {
  image?: string;
  imageAlt?: string;
  imageAttribution?: string;
  imageSourceUrl?: string;
}

export function parseImageFields(meta: Record<string, string>): ContentImage {
  return {
    image: meta.image || undefined,
    imageAlt: meta.imageAlt || undefined,
    imageAttribution: meta.imageAttribution || undefined,
    imageSourceUrl: meta.imageSourceUrl || undefined,
  };
}
